import { useEffect } from 'react';
import Navbar from '@/components/base/Navbar';
import Footer from '@/components/base/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import CommunityStats from './components/CommunityStats';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '海角社区',
    url: 'https://www.haijiao.cn/',
    description: '海角社区是国内知名的情感交流与生活分享社区，汇聚海量真实用户，提供情感倾诉、生活故事、同城交友等多元内容板块。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.haijiao.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '海角社区',
    url: 'https://www.haijiao.cn/',
    description: '真实用户聚集的情感交流平台',
    email: 'contact@haijiao.cn',
    telephone: '400-888-6666',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '杭州',
      addressRegion: '浙江',
      addressCountry: 'CN',
      streetAddress: '文三路478号',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '海角社区 - 真实用户聚集的情感交流平台',
    description: '海角社区是国内知名的情感交流与生活分享社区，汇聚海量真实用户，提供情感倾诉、生活故事、同城交友等多元内容板块。加入海角社区，找到志同道合的伙伴。',
    url: 'https://www.haijiao.cn/',
    isPartOf: { '@type': 'WebSite', name: '海角社区', url: 'https://www.haijiao.cn/' },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '海角社区是什么？', acceptedAnswer: { '@type': 'Answer', text: '海角社区是国内知名的情感交流与生活分享社区平台，汇聚了来自全国各地的真实用户。在这里，你可以倾诉情感困惑、分享生活故事、结交志同道合的朋友，找到归属感和理解。' } },
      { '@type': 'Question', name: '海角社区是否免费使用？', acceptedAnswer: { '@type': 'Answer', text: '是的，海角社区完全免费。注册、浏览、发布内容、互动交流等所有基础功能均不收取任何费用。' } },
      { '@type': 'Question', name: '如何在海角社区发布内容？', acceptedAnswer: { '@type': 'Answer', text: '注册并登录海角社区账号后，点击首页的发布按钮，选择相应的内容板块，即可撰写并发布你的文章或帖子。' } },
      { '@type': 'Question', name: '我的隐私信息安全吗？', acceptedAnswer: { '@type': 'Answer', text: '海角社区高度重视用户隐私保护。我们采用业界先进的数据加密技术，严格遵循相关法律法规。' } },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedArticles />
          <CommunityStats />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}